import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TypesAccumulationType } from "../../app/types/genericTables.types";

type useAccumulationType = {
  typesAccumulationList: TypesAccumulationType[];
  get: (id: TypesAccumulationType["id"]) => TypesAccumulationType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useTypesAccumulation = create<useAccumulationType>((set, get) => ({
  loading: false,
  typesAccumulationList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().typesAccumulationList.find((type) => type.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/TypesAccumulation";
      const { data: response } = await getData(endpoint);
      set(() => ({
        typesAccumulationList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching typesAccumulation:", error);
      set({ loading: false });
    }
  },
}));
